import React from 'react';
import OptionalVideoUpload from './OptionalVideoUpload';

/**
 * Old Mobile unit: Photos (max 3) YA short video — dono ek saath nahi.
 */
export default function UnitRealMediaPicker({
  mediaMode = 'none',
  onMediaModeChange,
  photoFiles = [],
  onPhotoFilesChange,
  videoFile,
  onVideoFileChange,
  inputName = 'unit-real-media-mode'
}) {
  const setMode = (mode) => {
    onMediaModeChange(mode);
    if (mode !== 'photos') onPhotoFilesChange([]);
    if (mode !== 'video') onVideoFileChange(null);
  };

  return (
    <div className="mb-2">
      <label className="form-label">Asli photos ya condition video</label>
      <div className="row g-2 mb-2">
        {[
          { id: 'none', label: 'Skip' },
          { id: 'photos', label: 'Photos (max 3)' },
          { id: 'video', label: 'Video (~30s)' }
        ].map(({ id, label }) => (
          <div className="col-12 col-md-4" key={id}>
            <label
              className={`border rounded px-2 py-2 w-100 d-flex align-items-center gap-2 ${
                mediaMode === id ? 'bg-primary text-white border-primary' : 'bg-white'
              }`}
              style={{ cursor: 'pointer' }}
            >
              <input
                type="radio"
                name={inputName}
                checked={mediaMode === id}
                onChange={() => setMode(id)}
              />
              <span className="small fw-semibold">{label}</span>
            </label>
          </div>
        ))}
      </div>
      <div className="border rounded p-2 bg-light mb-2">
        <label className="form-label small mb-1">Choose real photos</label>
        <input
          type="file"
          className="form-control form-control-sm"
          accept="image/jpeg,image/png,image/webp,image/*"
          multiple
          onChange={(e) => {
            const files = Array.from(e.target.files || []).slice(0, 3);
            onPhotoFilesChange(files);
            if (files.length) {
              onVideoFileChange(null);
              onMediaModeChange('photos');
            }
            e.target.value = '';
          }}
        />
        <small className="text-muted">
          {(photoFiles || []).length} file(s) selected
        </small>
      </div>
      <div className="border rounded p-2 bg-light">
        <OptionalVideoUpload
          title="Choose real condition video"
          file={videoFile}
          onChange={(file) => {
            onVideoFileChange(file);
            if (file) {
              onPhotoFilesChange([]);
              onMediaModeChange('video');
            }
          }}
          className="mb-0"
        />
      </div>
      <small className="text-muted d-block mt-1">
        Jahan video zaroori lage wahan video; baaki photos. Sale / transfer / customer site par wahi dikhega.
      </small>
    </div>
  );
}
